import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { baseUrl } from '../../constant';
import { useAppSelector } from '../../config/hooks';
import LoadingIcon from '../../assets/Icons/LoadingIcon';

const DocToImageViewer = ({ docUrl }) => {
  const {session}=useAppSelector((state)=>state.login) 
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  useEffect(()=>{
     fetchImages()
  },[])

  const fetchImages = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        'https://api.prod.linkcxo.com/v1/doc2image',
        { doc_url: docUrl },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      // .then((res)=>{console.log("INSIDE",res.data); setImages(res.data)});
      // console.log(response.data,"CHECKING")
      // console.log(response.data,"IMages")
      // Assuming response.data.images contains an array of image URLs
      if (response.data && Array.isArray(response.data.images)) {
        setImages(response.data.images);
      } else {
        throw new Error('Unexpected API response format');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to load document images.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-w-[30vw] w-full max-w-4xl mx-auto px-4 py-6 overflow-auto h-[70vh]">
      {/* <button
        onClick={fetchImages}
        disabled={loading}
        className="px-6 py-2 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? 'Loading...' : 'Load PDF Images'}
      </button> */}
     {loading &&  <div className='flex justify-center items-center h-full no-scrollbar'>
                    <h1 className='flex gap-4'>Loading... <LoadingIcon/> </h1>
                  </div>
                  }
     {/* {loading &&  } */}

      {error && <p className="text-red-500 mt-4">{error}</p>}

      <div className="mt-6 flex flex-col gap-6 ">
        {images && images?.map((img, index) => (
          <img
            key={index}
            // src={`${baseUrl}/${img}?t=${session.token}`}
            src={img}
            alt={`Page ${index + 1}`}
            className="w-full rounded shadow-md"
          />
        ))}
      </div>
    </div>
  );
};

export default DocToImageViewer;
